<template>
  <div class="flex inset-x-0 bottom-0 absolute z-1 duration" data-test-id="vf-media-gallery-pagination">
    <div
      v-for="(_, key) in pages"
      :key
      class="grow duration"
      :class="activePage === key ? 'bg-brand-4' : 'bg-transparent'"
      style="height: 0.125rem"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  activePage: number
  pages: number
}>()
</script>
